export default __webpack_public_path__ + "static/media/getAcces.158aa5b8.png";